import { CardHeader, styled } from "common/components";

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  position: "sticky",
  top: 0,
  backgroundColor: "white",
  zIndex: 100,
}));
